/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as React from "react";
import { createValidator } from "not-valid";
import * as moment from "moment";
import {
    Container,
    Segment,
    Loader,
    Divider,
    Grid,
    Header,
    List
} from "semantic-ui-react";

import { AccordionQuestionnaireContainer } from "@teamprevent/common/questionnaires/components/AccordionQuestionnaireContainer";
import { AccordionQuestionnaireSection } from "@teamprevent/common/questionnaires/components/AccordionQuestionnaireSection";
import { TextQuestion } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";
import { MultiButtonQuestion, YesOption } from "@teamprevent/common/questionnaires/components/questions/MultiButtonQuestion";
import { DropdownQuestion } from "@teamprevent/common/questionnaires/components/questions/DropdownQuestion";
import { OldDateQuestion } from "@teamprevent/common/questionnaires/components/questions/OldDateQuestion";
import { NumberQuestion } from "@teamprevent/common/questionnaires/components/questions/NumberQuestion";
import { EmployeeRecord, ConsultationDetails } from "@teamprevent/common/model";
import { AnsweredQuestion, AnsweredQuestionWithId, QuestionAnswer, QuestionnaireTypes } from "@teamprevent/common/questionnaires/model";
import { PrintDialog } from "@teamprevent/common/components/PrintDialog";
import { getAnswerToQuestionWithId } from "@teamprevent/common/questionnaires/getAnswerToQuestionWithId";

import { ReportWithdrawnInfo } from "@teamprevent/common/reportsCommon/components/ReportWithdrawnInfo";

import {
    classificationQuestionOptions,
    fitnessToWorkQuestionOptions,
    durationOfPhasedReturnQuestionOptionsLegacy,
    functionalAssessmentTestOptions,
    FunctionalAssessmentTestType,
    dropdownFunctionalAssessmentTestOptions,
    psychologicalAssessmentOutcomeQuestionOptions,
    barriers,
    riskAssessmentRecommendationQuestionOptions,
    RiskAssessmentRecommendation,
    durationOfMedicalConditionQuestionOptions,
    applyEqualityActQuestionOptions,
    detailsOfOnwardReferralQuestionOptions,
    DetailsOfOnwardReferral,
    detailsOfFurtherAppointmentsQuestionOptions,
    adjustmentOptions,
    Adjustments,
    adjustmentsRecommendedOptions,
    notInThePastValidator,
    notMoreThan12WeeksInTheFuture,
    Classification,
    ApplyEqualityAct,
    PsychologicalAssessmentOutcome,
    getPsychologicalWellbeingWSASOutcomeOptions,
    getPsychologicalWellbeingGAD7OutcomeOptions,
    dateInThePastWarning,
    CurrentStatus,
    currentStatusOptions,
    injuredQuestionOptions,
    levelOptions,
    medicalClassificationSubCategoryOptions,
    ohaMedicalClassificationOptions,
    originTypeOptions,
    symptomsOptions,
    toyotaClinicalNotesLevelOptions
} from "@teamprevent/common/referralReport/models";

import { ViewClinicalHistoryButton } from "@teamprevent/common/referralReport/components/ViewClinicalHistoryButton";

import { ViewClinicalNotesButton } from "@teamprevent/common/referralReport/components/ViewClinicalNotesButton";

import { TaskModel, TaskTypes } from "../../task/taskActions/models";
import { consultationMethodOptions, useHrAndLineManagers } from "../../reportsCommon/reportsCommon";
import { MultiCheckbox, MultiCheckboxQuestion } from "../../questionnaires/components/questions/MultiCheckboxQuestion";
import { EmployeeReleaseReportWithCommentsInfo } from "../../reportsCommon/components/EmployeeReleaseReportWithCommentsInfo";
import { QuestionConfig } from "../../questionnaires/questionnaireConfig";

import { ConsentWithdrawnInfo } from "../../reportsCommon/components/ConsentWithdrawnInfo";
import { PHYSIOTHERAPY_REFERRAL_REPORT_KEY, PhysiotherapyReferralReportDetails } from "../models";

export const clinicianNameQuestion = { questionText: "Occupational Health Adviser", id: "CliniciansName" };
export const clinicianQualificationQuestion = { questionText: "", id: "CliniciansQualification" };
export const clinicianEmailQuestion = { questionText: "Clinician's email", id: "CliniciansEmail" };

export interface ReportModel {
    questions: AnsweredQuestionWithId[];
    eTag: string | null | undefined;
    isDefaultCustomerType?: boolean;
    customerType?: string;
}

export interface PhysiotherapyReferralReportPropsBase {
    submitQuestionnaire?: (report: ReportModel) => Promise<boolean>;
    extraSections?: { title: string; id: string; content: React.ReactNode }[];
    fromAdmin?: boolean;
    isReportPreview?: boolean;
    extraQuestionContent?: { [questionId: string]: React.ReactNode };
    oldVersionRedirectUrl?: string;
    version: number;
    redirectData?: {
        customerId?: string;
        employeeRecordId?: string;
        ohCaseId?: string;
        viewReportTaskId?: string;
        reviewReportTaskId?: string;
        taskId?: string;
    };
    navigateToOldReport: (url: string) => void;
    reportDetails: PhysiotherapyReferralReportDetails | null;

    customerId: string;
    ohCaseId: string;
    taskId: string;
    task?: TaskModel;
    ohCase: { employeeRecordId: string } | null;
    employeeRecord: EmployeeRecord | null;
    report: ReportModel;
    consultationAndReferralDetails: ConsultationDetails;
    loading?: boolean;
    useToyotaTemplates: boolean;

    loadEmployee: (employeeRecordId: string, customerId: string) => void;
    updateAnswer: (payload: { sectionId: string; id: string; question: AnsweredQuestion }, questionnaireKey: string) => void;
    loadQuestionnaire: (
        questionnaireKey: string, ohCaseId: string, taskId: string, customerId: string, omittedSections?: string[]
    ) => Promise<PhysiotherapyReferralReportDetails> | null;
    clearQuestionnaire: (questionnaireKey: string) => void;
    submitInvalidQuestionnaire: (questionnaireKey: string) => void;
    onCompletion: () => void;
    loadConsultationDetails: (ohCaseId: string, customerId: string) => void;
}

export interface ReadOnlyProps extends PhysiotherapyReferralReportPropsBase {
    readonly: true;
}

export interface EditableProps extends PhysiotherapyReferralReportPropsBase {
    readonly: false;
    saveReport: (ohCaseId: string, taskId: string, report: ReportModel) => Promise<void>;
}

export type PhysiotherapyReferralReportProps = ReadOnlyProps | EditableProps;

interface BoolDictionary {
    [name: string]: boolean;
}

interface QuestionAnswerDictionary {
    [name: string]: QuestionAnswer;
}

interface State {
    redirectChecked: boolean;
    redirecting: boolean;
    visibilitiesChecked: boolean;
    visibilities?: BoolDictionary;
    readonlyData?: QuestionAnswerDictionary;
}

const isDateInThePast = (value: moment.Moment) => {
    return value?.isSameOrBefore(moment().startOf("day"));
};

export class PhysiotherapyReferralReport extends React.Component<PhysiotherapyReferralReportProps, State> {
    public readonly summarySectionId = "Summary";
    public readonly reportDetailsSectionId = "ReportDetails";
    public readonly employeeDetailsSectionId = "EmployeeDetails";
    public readonly mentalAndEmotionalHealthSectionId = "MentalAndEmotionalHealth";
    public readonly barriersAnswersSectionId = "BarriersAnswers";
    public readonly fitnessForWorkSectionId = "FitnessToWork";
    public readonly returnToWorkSectionId = "ReturnToWork";
    public readonly healthConcernDetails = "HealthConcernDetails";

    public readonly reportDateQuestion = { questionText: "Date", id: "Date" };
    public readonly workClassificationQuestion = { questionText: "Work Classification", id: "WorkClassificationText" };
    public readonly durationOfPhasedReturnQuestion = { questionText: "Recommended Length of Phased Return", id: "DurationOfPhasedReturnText" };
    public readonly hrAndLineManagersQuestion = { questionText: "HR / Manager", id: "HrManager" };
    public readonly adjustmentsQuestion = { id: "Adjustments", questionText: "Adjustments" };
    public readonly adjustmentsRecommendedQuestion = { id: "AdjustmentsRecommended", questionText: "Adjustments recommended" };
    public readonly endDateOfTemporaryAdjustmentsQuestion = { id: "AdjustmentsEndDate", questionText: "End Date of Temporary Adjustments" };
    public readonly classificationQuestion = { id: "OutcomeAndOnwardManagementOfTheCaseClassification", questionText: "Classification" };
    public readonly fitnessToWorkQuestion = { id: "OutcomeAndOnwardManagementOfTheCaseFitnessToWork", questionText: "Fitness to Work" };
    private readonly outcomeAndOnwardManagementOfTheCaseApplyEqualityActQuestion = {
        id: "OutcomeAndOnwardManagementOfTheCaseApplyEqualityAct",
        questionText: "Is the Equality Act Likely to Apply? Please note this is in the opinion of the Occupational Health "
            + "Clinician but ultimately the decision is a legal one."
    };
    public readonly currentStatusQuestion = { id: "CurrentStatus", questionText: "Current Status" };

    public readonly referralReportCurrentVersionQuestionId = "ReferralReportCurrentVersion";
    public readonly medicalClassificationQuestionId = "MedicalClassification";
    public readonly medicalClassificationSubCategoryQuestionId = "MedicalClassificationSubCategory";

    constructor(props: PhysiotherapyReferralReportProps) {
        super(props);

        this.loadQuestionnaire = this.loadQuestionnaire.bind(this);
        this.submitQuestionnaire = this.submitQuestionnaire.bind(this);
        this.autoSaveQuestionnaire = this.autoSaveQuestionnaire.bind(this);
        props.clearQuestionnaire(PHYSIOTHERAPY_REFERRAL_REPORT_KEY);

        if (this.props.ohCase) {
            this.props.loadEmployee(this.props.ohCase.employeeRecordId, this.props.customerId);
        }

        if (this.props.taskId && this.props.ohCaseId) {
            this.props.loadConsultationDetails(this.props.ohCaseId, this.props.taskId);
        }

        this.state = {
            redirectChecked: false,
            redirecting: false,
            visibilitiesChecked: false,
            visibilities: {},
            readonlyData: {}
        };

        this.isEmployeeIsUnlikelyToReturnForTheForeseeableFuture = this.isEmployeeIsUnlikelyToReturnForTheForeseeableFuture.bind(this);
    }

    public async loadQuestionnaire() {
        let omittedSections: string[] = [];

        // AmendReportTask form shouldn't overwrite employee details section from old form
        if (this.props.task?.type === TaskTypes.AmendReportTask) {
            omittedSections = [...omittedSections, "EmployeeDetails"];
        }

        await this.props.loadQuestionnaire(PHYSIOTHERAPY_REFERRAL_REPORT_KEY, this.props.ohCaseId, this.props.taskId, this.props.customerId, omittedSections);
    }

    public submitQuestionnaire(questions: AnsweredQuestionWithId[])
    {
        return this.props.submitQuestionnaire(
            {
                questions,
                eTag: this.props.report.eTag,
                isDefaultCustomerType: this.props.report.isDefaultCustomerType,
                customerType: this.props.report.customerType
            });
    }

    public autoSaveQuestionnaire(questions: AnsweredQuestionWithId[], eTag: string | null)
    {
        if (this.props.readonly === true) { return Promise.reject(); }

        return this.props.saveReport(this.props.ohCaseId, this.props.taskId, {
            questions,
            eTag,
            isDefaultCustomerType: this.props.report.isDefaultCustomerType,
            customerType: this.props.report.customerType
        });
    }

    private getQuestionsWithId(id: string): QuestionConfig {
        const question = this.props.report.questions.find(q => q.id === id);

        return {
            id,
            questionText: question?.question || ""
        };
    }

    private getQuestionText(id: string) {
        const question = this.props.report.questions.find(q => q.id === id);

        return question?.question || "";
    }

    private getQuestionsWithSectionId(sectionId: string) {
        return this.props.report.questions.filter(question => question.sectionId === sectionId);
    }

    private getAnswersToQuestionWithSectionId(sectionId: string) {
        return this.props.report.questions.filter(question => question.sectionId === sectionId && !question.isHidden).map(question => question.id);
    }

    private getVisibilityOfQuestionWithId(id: string) {
        const question = this.props.report.questions.find(q => q.id === id);
        return !!(question && !question.isHidden);
    }

    private getAnswerToQuestionWithId(id: string) {
        const question = this.props.report.questions.find(q => q.id === id);
        return question?.answer;
    }

    private getClassificationSubCategoryOptions() {
        return medicalClassificationSubCategoryOptions[getAnswerToQuestionWithId(
            this.props.report.questions,
            this.medicalClassificationQuestionId) as string] ?? [];
    }

    private isEmployeeIsUnlikelyToReturnForTheForeseeableFuture() {
        const answer = this.getAnswerToQuestionWithId("OutcomeAndOnwardManagementOfTheCaseEmployeeUnlikelyToReturn");
        return answer === YesOption;
    }

    private onMedicalClassificationChanged = () => {
        // If sub category question is not removed on change of category,
        // the drop down on the UI shows no item selected for the sub classification,
        // but the form can be submited as the questions array has the previous answer
        const question = this.props.report.questions.find(q => q.id === this.medicalClassificationSubCategoryQuestionId);

        if (question) {
            this.props.updateAnswer(
                {
                    id: this.medicalClassificationSubCategoryQuestionId,
                    sectionId: this.healthConcernDetails,
                    question: {
                        ...question,
                        answer: null
                    }
                },
                PHYSIOTHERAPY_REFERRAL_REPORT_KEY
            );
        }
    };

    public componentDidUpdate?(prevProps: Readonly<PhysiotherapyReferralReportProps>) {
        if (!this.state.redirectChecked && this.props.report.questions.some(q => q.id === this.referralReportCurrentVersionQuestionId))
        {
            const currentClinicalNotesVersion = this.getAnswerToQuestionWithId(this.referralReportCurrentVersionQuestionId) as number;
            if (currentClinicalNotesVersion !== this.props.version && this.props.oldVersionRedirectUrl) {
                this.setState({ redirecting: true, redirectChecked: true }, () => {
                    let url = this.props.oldVersionRedirectUrl!;

                    url = url.replace(":version", currentClinicalNotesVersion.toString());

                    if (this.props.redirectData?.customerId) {
                        url = url.replace(":customerId", this.props.redirectData.customerId);
                    }

                    if (this.props.redirectData?.employeeRecordId) {
                        url = url.replace(":employeeRecordId", this.props.redirectData.employeeRecordId);
                    }

                    if (this.props.redirectData?.ohCaseId) {
                        url = url.replace(":ohCaseId", this.props.redirectData.ohCaseId);
                    }

                    if (this.props.redirectData?.viewReportTaskId) {
                        url = url.replace(":viewReportTaskId", this.props.redirectData.viewReportTaskId);
                    }

                    if (this.props.redirectData?.reviewReportTaskId) {
                        url = url.replace(":reviewReportTaskId", this.props.redirectData.reviewReportTaskId);
                    }

                    if (this.props.redirectData?.taskId) {
                        url = url.replace(":taskId", this.props.redirectData.taskId);
                    }

                    this.props.navigateToOldReport(url);
                });
            } else {
                this.setState({ redirecting: false, redirectChecked: true });
            }
        }

        if (this.props.ohCase && this.props.ohCase !== prevProps.ohCase) {
            this.props.loadEmployee(this.props.ohCase.employeeRecordId, this.props.customerId);
        }

        if (this.props.taskId && this.props.taskId !== prevProps.taskId &&
            this.props.ohCaseId && this.props.ohCaseId !== prevProps.ohCaseId) {
            this.props.loadConsultationDetails(this.props.ohCaseId, this.props.taskId);
        }

        // #68707 - For legacy reports, question with id "AnswersToSpecificQuestions" may be saved.
        // For new questions, use the same section and question name as the ReferralForm to pull saved data.
        // #69743 - The "AdditionalInfo" question is also legacy now.
        // The new format displays separate text boxes for each additional question.
        const oldAdditionalQuestionAnswered = !!this.getAnswerToQuestionWithId("AnswersToSpecificQuestions");
        let newSingleAdditionalQuestionAnswered = false;
        let newSeparateAdditionalQuestionRequired = false;

        if (!oldAdditionalQuestionAnswered) {
            newSeparateAdditionalQuestionRequired = !!this.getAnswerToQuestionWithId("SeparateAdditionalQuestionAnswersRequired");

            if (!newSeparateAdditionalQuestionRequired) {
                newSingleAdditionalQuestionAnswered = !!this.getAnswerToQuestionWithId("AdditionalInfo")
                    || this.getQuestionsWithSectionId("InformationRequired").length > 0;
            }
        }

        const isReportLoaded = this.props.report?.eTag !== undefined;
        if (!this.state.visibilitiesChecked && isReportLoaded && this.props.report.questions.some(
            q => ["EmployeeDetails", "CurrentManagementOfHealth", "FutureManagementOfHealth", "ReadonlyData"].indexOf(q.sectionId) === -1)) {
            const simplifiedNotesAndReport = this.getAnswerToQuestionWithId("SimplifiedNotesAndReport") === "UseSimplifiedNotesAndReport";
            const functionalAssessmentTests = this.getAnswersToQuestionWithSectionId("FunctionalAssessmentTestsAnswers");
            const functionalAssessmentTestsConfigs = functionalAssessmentTestOptions.filter(
                ato => functionalAssessmentTests.some(c => c === "FunctionalCapacity" + ato.value)
            );

            this.setState({
                readonlyData: {
                    ClinicianName: this.getAnswerToQuestionWithId("ClinicianName"),
                    ClinicianJobTitle: this.getAnswerToQuestionWithId("ClinicianJobTitle"),
                    ClinicianQualifications: this.getAnswerToQuestionWithId("ClinicianQualifications"),
                    CustomerEmail: this.getAnswerToQuestionWithId("CustomerEmail"),
                    CustomerPhone: this.getAnswerToQuestionWithId("CustomerPhone")
                },
                visibilities: {
                    OutcomeAndOnwardManagementOfTheCaseClassificationVisible:
                        this.getVisibilityOfQuestionWithId("OutcomeAndOnwardManagementOfTheCaseClassification"),
                    OutcomeAndOnwardManagementOfTheCaseFitnessToWorkVisible:
                        this.getVisibilityOfQuestionWithId("OutcomeAndOnwardManagementOfTheCaseFitnessToWork"),
                    NotesVisible: simplifiedNotesAndReport,
                    FunctionalCapacityCommentsOnFunctionalCapacityVisible:
                        !simplifiedNotesAndReport && this.getVisibilityOfQuestionWithId("FunctionalCapacityCommentsOnFunctionalCapacity"),
                    FunctionalAssessmentTestsVisible: !simplifiedNotesAndReport && functionalAssessmentTestsConfigs.length > 0,
                    PsychologicalWellbeingPHQ9OutcomeVisible:
                        !simplifiedNotesAndReport && this.getVisibilityOfQuestionWithId("PsychologicalWellbeingPHQ9Outcome"),
                    PsychologicalWellbeingGAD7OutcomeVisible:
                        !simplifiedNotesAndReport && this.getVisibilityOfQuestionWithId("PsychologicalWellbeingGAD7Outcome"),
                    PsychologicalWellbeingWSASOutcomeVisible:
                        !simplifiedNotesAndReport && this.getVisibilityOfQuestionWithId("PsychologicalWellbeingWSASOutcome"),
                    MentalHealthCommentsOnMentalAndEmotionalWellbeingVisible:
                        !simplifiedNotesAndReport && this.getVisibilityOfQuestionWithId("MentalHealthCommentsOnMentalAndEmotionalWellbeing"),
                    BarriersVisible:
                        !simplifiedNotesAndReport && this.getAnswerToQuestionWithId("CarryOutPsychosocialBarriersToWork") === YesOption,
                    PsychosocialBarriersDetailsVisible:
                        !simplifiedNotesAndReport && this.getVisibilityOfQuestionWithId("PsychosocialBarriersDetails"),
                    StandardClinicalDetailsReasonForReferralVisible:
                        !simplifiedNotesAndReport && this.getVisibilityOfQuestionWithId("StandardClinicalDetailsReasonForReferral"),
                    CurrentManagementOfHealthVisible: !simplifiedNotesAndReport,
                    FutureManagementOfHealthVisible: !simplifiedNotesAndReport,
                    OutcomeAndOnwardManagementOfTheCaseRiskAssessmentRecommendationsVisible:
                        this.getVisibilityOfQuestionWithId("OutcomeAndOnwardManagementOfTheCaseRiskAssessmentRecommendations"),
                    OutcomeAndOnwardManagementOfTheCaseDescriptionOfThePhysicalOrMentalImpairmentVisible:
                        !simplifiedNotesAndReport
                        && this.getVisibilityOfQuestionWithId("OutcomeAndOnwardManagementOfTheCaseDescriptionOfThePhysicalOrMentalImpairment"),
                    OutcomeAndOnwardManagementOfTheCaseDurationOfMedicalConditionVisible:
                        !simplifiedNotesAndReport && this.getVisibilityOfQuestionWithId("OutcomeAndOnwardManagementOfTheCaseDurationOfMedicalCondition"),
                    OutcomeAndOnwardManagementOfTheCaseEffectOfMedicalConditionVisible:
                        !simplifiedNotesAndReport && this.getVisibilityOfQuestionWithId("OutcomeAndOnwardManagementOfTheCaseEffectOfMedicalCondition"),
                    OutcomeAndOnwardManagementOfTheCaseApplyEqualityActVisible:
                        !simplifiedNotesAndReport && this.getVisibilityOfQuestionWithId("OutcomeAndOnwardManagementOfTheCaseApplyEqualityAct"),
                    OutcomeAndOnwardManagementOfTheCaseDetailsOfOnwardReferralVisible:
                        this.getVisibilityOfQuestionWithId("OutcomeAndOnwardManagementOfTheCaseDetailsOfOnwardReferral"),
                    OutcomeAndOnwardManagementOfTheCaseDetailsOfFurtherAppointmentsVisible:
                        this.getVisibilityOfQuestionWithId("OutcomeAndOnwardManagementOfTheCaseDetailsOfFurtherAppointments"),
                    OutcomeAndOnwardManagementOfTheCaseFurtherMedicalInformationBeingRequestedVisible:
                        this.getVisibilityOfQuestionWithId("OutcomeAndOnwardManagementOfTheCaseFurtherMedicalInformationBeingRequested"),
                    OldAdditionalQuestionVisible:
                        !simplifiedNotesAndReport && oldAdditionalQuestionAnswered,
                    NewSingleAdditionalQuestionVisible:
                        !simplifiedNotesAndReport && newSingleAdditionalQuestionAnswered,
                    NewSeparateAdditionalQuestionRequired:
                        !simplifiedNotesAndReport && newSeparateAdditionalQuestionRequired
                },
                visibilitiesChecked: true
            });
        }

        if (!this.props.readonly) {
            this.updateManagersAnswer();
        }
    }

    private updateManagersAnswer() {
        const hrAndLineManagersQuestionAnswer = this.getAnswerToQuestionWithId(this.hrAndLineManagersQuestion.id);
        const currentOhCaseManagers = useHrAndLineManagers(this.props.consultationAndReferralDetails); // eslint-disable-line react-hooks/rules-of-hooks
        if ((hrAndLineManagersQuestionAnswer && currentOhCaseManagers) && hrAndLineManagersQuestionAnswer !== currentOhCaseManagers) {
            this.props.updateAnswer(
                {
                    sectionId: this.employeeDetailsSectionId,
                    id: this.hrAndLineManagersQuestion.id,
                    question: { question: this.hrAndLineManagersQuestion.questionText, answer: currentOhCaseManagers, isValid: true }
                },
                PHYSIOTHERAPY_REFERRAL_REPORT_KEY
            );
        }
    }

    public updateSnippets = (snippetText: string, sectionId: string, id: string, questionText: string) => {
        const currentAnswer = this.getAnswerToQuestionWithId(id);

        const question = {
            question: questionText,
            answer: (currentAnswer ? currentAnswer + " " : "") + snippetText,
            isValid: true
        };

        this.props.updateAnswer({ sectionId, id, question }, PHYSIOTHERAPY_REFERRAL_REPORT_KEY);
    };

    public getChoosenDetails(questionId: string): string[] {
        const answer = this.getAnswerToQuestionWithId(
            questionId
        );

        if (!answer) {
            return [];
        }

        if (Array.isArray(answer)) {
            return answer as string[];
        }

        if (typeof answer === "string") {
            return [answer];
        }

        return [];
    }

    public render() {
        if (this.props.loading) {
            return <Loader active />;
        }

        const OutcomeAndOnwardManagementOfTheCaseClassificationVisible =
            this.state.visibilities?.OutcomeAndOnwardManagementOfTheCaseClassificationVisible || false;
        const OutcomeAndOnwardManagementOfTheCaseFitnessToWorkVisible =
            this.state.visibilities?.OutcomeAndOnwardManagementOfTheCaseFitnessToWorkVisible || false;
        const OutcomeAndOnwardManagementOfTheCaseEstimatedReturnToWorkDateVisible =
            this.getVisibilityOfQuestionWithId("OutcomeAndOnwardManagementOfTheCaseEstimatedReturnToWorkDate");
        const OutcomeAndOnwardManagementOfTheCasePhasedReturnVisible =
            this.getVisibilityOfQuestionWithId("OutcomeAndOnwardManagementOfTheCasePhasedReturn");
        const OutcomeAndOnwardManagementOfTheCaseCommentOnReturnToWorkVisible =
            this.getVisibilityOfQuestionWithId("OutcomeAndOnwardManagementOfTheCaseCommentOnReturnToWork");
        const FunctionalCapacityCommentsOnFunctionalCapacityVisible =
            this.state.visibilities?.FunctionalCapacityCommentsOnFunctionalCapacityVisible || false;
        const FunctionalAssessmentTestsVisible =
            this.state.visibilities?.FunctionalAssessmentTestsVisible || false;
        const PsychologicalWellbeingPHQ9OutcomeVisible =
            this.state.visibilities?.PsychologicalWellbeingPHQ9OutcomeVisible || false;
        const PsychologicalWellbeingGAD7OutcomeVisible =
            this.state.visibilities?.PsychologicalWellbeingGAD7OutcomeVisible || false;
        const PsychologicalWellbeingWSASOutcomeVisible =
            this.state.visibilities?.PsychologicalWellbeingWSASOutcomeVisible || false;
        const MentalHealthCommentsOnMentalAndEmotionalWellbeingVisible =
            this.state.visibilities?.MentalHealthCommentsOnMentalAndEmotionalWellbeingVisible || false;
        const BarriersVisible =
            this.state.visibilities?.BarriersVisible || false;
        const PsychosocialBarriersDetailsVisible = this.state.visibilities?.PsychosocialBarriersDetailsVisible || false;
        const StandardClinicalDetailsReasonForReferralVisible =
            this.state.visibilities?.StandardClinicalDetailsReasonForReferralVisible || false;
        const CurrentManagementOfHealthVisible = this.state.visibilities?.CurrentManagementOfHealthVisible || false;
        const FutureManagementOfHealthVisible = this.state.visibilities?.FutureManagementOfHealthVisible || false;
        // const InformationRequiredQuestionsVisible =
        //     this.state.visibilities?.InformationRequiredQuestionsVisible || false;
        const NotesVisible = this.state.visibilities?.NotesVisible || false;
        const OutcomeAndOnwardManagementOfTheCaseRiskAssessmentRecommendationsVisible =
            this.state.visibilities?.OutcomeAndOnwardManagementOfTheCaseRiskAssessmentRecommendationsVisible || false;
        const OutcomeAndOnwardManagementOfTheCaseDescriptionOfThePhysicalOrMentalImpairmentVisible =
            this.state.visibilities?.OutcomeAndOnwardManagementOfTheCaseDescriptionOfThePhysicalOrMentalImpairmentVisible || false;
        const OutcomeAndOnwardManagementOfTheCaseDurationOfMedicalConditionVisible =
            this.state.visibilities?.OutcomeAndOnwardManagementOfTheCaseDurationOfMedicalConditionVisible || false;
        const OutcomeAndOnwardManagementOfTheCaseEffectOfMedicalConditionVisible =
            this.state.visibilities?.OutcomeAndOnwardManagementOfTheCaseEffectOfMedicalConditionVisible || false;
        const OutcomeAndOnwardManagementOfTheCaseApplyEqualityActVisible =
            this.state.visibilities?.OutcomeAndOnwardManagementOfTheCaseApplyEqualityActVisible || false;
        const OutcomeAndOnwardManagementOfTheCaseDetailsOfOnwardReferralVisible =
            this.state.visibilities?.OutcomeAndOnwardManagementOfTheCaseDetailsOfOnwardReferralVisible || false;
        const OutcomeAndOnwardManagementOfTheCaseDetailsOfFurtherAppointmentsVisible =
            this.state.visibilities?.OutcomeAndOnwardManagementOfTheCaseDetailsOfFurtherAppointmentsVisible || false;
        const OutcomeAndOnwardManagementOfTheCaseFurtherMedicalInformationBeingRequestedVisible =
            this.state.visibilities?.OutcomeAndOnwardManagementOfTheCaseFurtherMedicalInformationBeingRequestedVisible || false;
        const OldAdditionalQuestionVisible =
            this.state.visibilities?.OldAdditionalQuestionVisible || false;
        const NewSingleAdditionalQuestionVisible =
            this.state.visibilities?.NewSingleAdditionalQuestionVisible || false;
        const NewSeparateAdditionalQuestionRequired =
            this.state.visibilities?.NewSeparateAdditionalQuestionRequired || false;

        const consultationMethod = this.getAnswerToQuestionWithId("IntroductionAndDataPrivacyConsultationMethod");
        const consultationMethodText = consultationMethodOptions.find(o => o.value === consultationMethod)?.text;

        const choosenRiskAssessmentRecommendations = this.getChoosenDetails("OutcomeAndOnwardManagementOfTheCaseRiskAssessmentRecommendations");
        const choosenDetailsOfOnwardReferral = this.getChoosenDetails("OutcomeAndOnwardManagementOfTheCaseDetailsOfOnwardReferral");

        const functionalAssessmentTests = this.getAnswersToQuestionWithSectionId("FunctionalAssessmentTestsAnswers");
        const functionalAssessmentTestsConfigs = functionalAssessmentTestOptions.filter(
            ato => functionalAssessmentTests.some(c => c === "FunctionalCapacity" + ato.value)
        );

        const adjustmentQuestionAnswer = this.getAnswerToQuestionWithId(this.adjustmentsQuestion.id);
        const recommendedAdjustmentsQuestionVisible = adjustmentQuestionAnswer === Adjustments.ShortTerm || adjustmentQuestionAnswer === Adjustments.LongTerm;
        const adjustmentEndDateQuestionVisible = adjustmentQuestionAnswer === Adjustments.ShortTerm;
        const classificationQuestionAnswer = this.getAnswerToQuestionWithId(this.classificationQuestion.id);
        const workClassificationNotAtWork = classificationQuestionAnswer === Classification.NotAtWorkManagementIssue ||
            classificationQuestionAnswer === Classification.NotAtWorkMedicalCondition;
        const isCurrentStatusAbsent = this.getAnswerToQuestionWithId(this.currentStatusQuestion.id) === CurrentStatus.Absent;
        const isNotWorkingNormal = this.getAnswerToQuestionWithId(this.currentStatusQuestion.id) !== CurrentStatus.WorkingNormallyPPOandSPO;
        const outcomeAndOnwardManagementOfTheCaseApplyEqualityActQuestionAnswer =
            this.getAnswerToQuestionWithId(this.outcomeAndOnwardManagementOfTheCaseApplyEqualityActQuestion.id);

        const hrAndLineManagers = useHrAndLineManagers(this.props.consultationAndReferralDetails); // eslint-disable-line react-hooks/rules-of-hooks
        return (
            <Container className="referral-report">
                {(!this.props.isReportPreview && this.props.fromAdmin && this.props.ohCase) ? (
                    <>
                        <Container textAlign="right" className="start-button">
                            <>
                                <ViewClinicalHistoryButton
                                    customerId={this.props.customerId}
                                    employeeRecordId={this.props.ohCase.employeeRecordId}
                                />
                                <ViewClinicalNotesButton
                                    customerId={this.props.customerId}
                                    employeeRecordId={this.props.ohCase.employeeRecordId}
                                    ohCaseId={this.props.ohCaseId}
                                    consultationTaskId={this.props.consultationAndReferralDetails.consultationTaskId}
                                />
                            </>
                        </Container>
                    </>) : (
                    <Grid container>
                        <Grid.Row className="report-title-row">
                            <Grid.Column>
                                <Header as="h1">Referral Outcome Report</Header>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>)
                }
                <AccordionQuestionnaireContainer
                    autoSaveQuestionnaire={this.props.readonly ? undefined : this.autoSaveQuestionnaire}
                    loadQuestionnaire={this.loadQuestionnaire}
                    submitQuestionnaire={this.submitQuestionnaire}
                    loading={this.props.loading || this.state.visibilitiesChecked !== true}
                    readonly={this.props.readonly}
                    questionnaireKey={PHYSIOTHERAPY_REFERRAL_REPORT_KEY}
                    extraQuestionContent={this.props.extraQuestionContent}
                    submissionConfirmationText={
                        `You are submitting this report for ${this.props.employeeRecord?.firstName} ${this.props.employeeRecord?.lastName}.
                        Are you happy to continue?`
                    }
                    questionnaireType={QuestionnaireTypes.Report}
                >
                    <ConsentWithdrawnInfo reportDetails={this.props.reportDetails} />
                    <ReportWithdrawnInfo reportDetails={this.props.reportDetails} />
                    {this.props.employeeRecord &&
                    <>
                        <Header>PRIVATE AND CONFIDENTIAL</Header>
                        <List>
                            <List.Item>{this.props.employeeRecord.firstName} {this.props.employeeRecord.lastName}</List.Item>
                            {[
                                this.props.employeeRecord.addressLine1,
                                this.props.employeeRecord.addressLine2,
                                this.props.employeeRecord.addressLine3,
                                this.props.employeeRecord.city,
                                this.props.employeeRecord.county,
                                this.props.employeeRecord.postCode
                            ].filter(a => !!a).map((addressLine, index) => <List.Item key={index}>{addressLine}</List.Item>)}
                        </List>
                    </>
                    }
                    <AccordionQuestionnaireSection
                        title={this.props.report.isDefaultCustomerType === false ? "Details" : "Employee Details"}
                        id={this.employeeDetailsSectionId}
                        hideNextButton active>
                        <TextQuestion
                            hideDivider
                            inline
                            questionConfig={({ id: "Employee", questionText: this.props.report.isDefaultCustomerType === false ? "Name" : "Employee" })}
                            answer={this.props.employeeRecord ? `${this.props.employeeRecord.firstName} ${this.props.employeeRecord.lastName}` : ""}
                            readonly
                        />
                        <TextQuestion
                            hideDivider
                            inline
                            questionConfig={{ id: "EmployeeId", questionText: "" }}
                            answer={this.props.consultationAndReferralDetails?.employeeId}
                            hidden
                            readonly
                        />
                        <TextQuestion
                            hideDivider
                            inline
                            questionConfig={({ id: "EmployerAndDivision", questionText: "" })}
                            answer={this.props.employeeRecord &&
                                [
                                    this.props.employeeRecord.customerName,
                                    this.props.employeeRecord.orgStructureOne?.name
                                ].filter(t => t).join(" - ")
                            }
                            hidden
                            readonly
                        />
                        <OldDateQuestion
                            hideDivider
                            inline
                            questionConfig={({ id: "DateOfBirth", questionText: "Date of Birth" })}
                            answer={this.props.employeeRecord?.dateOfBirth?.format("YYYY-MM-DD")}
                            readonly
                        />
                        <TextQuestion
                            hideDivider
                            inline
                            questionConfig={({ id: "PersonalReferenceNumber", questionText: "Personal reference number" })}
                            answer={this.props.employeeRecord ? `${this.props.employeeRecord?.personalReferenceNumber}` : ""}
                            readonly
                        />
                        <TextQuestion
                            hideDivider
                            inline
                            questionConfig={({ id: "EmployeeUniqueID", questionText: "Employee Unique Id" })}
                            answer={this.props.employeeRecord ? `${this.props.employeeRecord?.secondaryReference}` : ""}
                            readonly
                        />
                        <TextQuestion
                            hideDivider
                            inline
                            questionConfig={({ id: "JobRole", questionText: "Job Role" })}
                            answer={this.props.employeeRecord ? `${this.props.employeeRecord.jobTitle}` : ""}
                            readonly
                        />
                        <TextQuestion
                            hideDivider
                            inline
                            questionConfig={this.hrAndLineManagersQuestion}
                            answer={hrAndLineManagers}
                            readonly
                        />
                        <TextQuestion
                            hideDivider
                            inline
                            questionConfig={({ id: "Worksite", questionText: "Worksite" })}
                            answer={this.props.employeeRecord &&
                                [
                                    this.props.employeeRecord.orgStructureOne?.name,
                                    this.props.employeeRecord.orgStructureTwo?.name
                                ].filter(t => t).join(" - ")
                            }
                            readonly
                        />
                        <TextQuestion
                            hideDivider
                            inline
                            questionConfig={({ id: "DateMethod", questionText: "Date & Method" })}
                            answer={`${this.props.consultationAndReferralDetails?.consultationDate?.format("DD/MM/YYYY")}, `
                                + `${consultationMethodText}`}
                            readonly
                        />
                        <Segment basic>
                            Thank you for your referral. I have undertaken a consultation today to discuss this referral, the
                            presenting health situation, fitness for work and identify any workplace support required. Verbal consent to
                            proceed with this consultation and generation of a functional outcome report has been confirmed. The general
                            content of the report has been discussed and a copy of the report will be sent via the portal.
                        </Segment>
                    </AccordionQuestionnaireSection>
                    { this.props.useToyotaTemplates &&
                        <AccordionQuestionnaireSection
                            title={"Health Concern Details"}
                            id={this.healthConcernDetails}
                            hideNextButton
                            active>
                            <OldDateQuestion
                                hideDivider
                                inline
                                mandatory={true}
                                readonly={this.props.readonly}
                                questionConfig={({ id: "StandardClinicalDetailsOnsetDate", questionText: "Onset Date" })}
                                validators={[createValidator((value: moment.Moment) => isDateInThePast(value), "Should be today or in the past")]}
                            />
                            <OldDateQuestion
                                hideDivider
                                inline
                                mandatory={true}
                                readonly={this.props.readonly}
                                questionConfig={({
                                    id: "DateIssueFirstRaised",
                                    questionText: "Date issue First Raised by Member"
                                })}
                                validators={[createValidator((value: moment.Moment) => isDateInThePast(value), "Should be today or in the past")]}
                            />
                            <MultiButtonQuestion
                                hideDivider
                                inline
                                mandatory={true}
                                readonly={this.props.readonly}
                                questionConfig={({
                                    id: "StandardClinicalDetailsFirstEpisode",
                                    questionText: "First Episode"
                                })}
                            />
                            <DropdownQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={({ id: this.medicalClassificationQuestionId, questionText: "Medical Classification" })}
                                filterOldOptions
                                options={ohaMedicalClassificationOptions}
                                mandatory
                                onAnswerChange={this.onMedicalClassificationChanged}
                            />
                            {this.getClassificationSubCategoryOptions().length > 0 &&
                                <DropdownQuestion
                                    hideDivider
                                    inline
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: this.medicalClassificationSubCategoryQuestionId,
                                        questionText: "Sub Category"
                                    })}
                                    filterOldOptions
                                    options={this.getClassificationSubCategoryOptions()}
                                    mandatory
                                />
                            }
                            <DropdownQuestion
                                hideDivider
                                inline
                                mandatory={true}
                                readonly={this.props.readonly}
                                questionConfig={({ id: "StandardClinicalDetailsInjured", questionText: "Origin" })}
                                options={injuredQuestionOptions}
                            />
                            <DropdownQuestion
                                hideDivider
                                inline
                                mandatory={true}
                                readonly={this.props.readonly}
                                questionConfig={({
                                    id: "StandardClinicalDetailsOriginType",
                                    questionText: "Origin Type"
                                })}
                                options={originTypeOptions}
                            />
                            <DropdownQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={({
                                    id: "Symptoms",
                                    questionText: "Symptoms"
                                })}
                                options={symptomsOptions}
                                mandatory
                                multiple
                            />
                        </AccordionQuestionnaireSection>
                    }
                    {!this.props.useToyotaTemplates && (OutcomeAndOnwardManagementOfTheCaseClassificationVisible
                        || OutcomeAndOnwardManagementOfTheCaseFitnessToWorkVisible) ? (
                            <AccordionQuestionnaireSection title="Fitness to Work" id={this.fitnessForWorkSectionId} hideNextButton active>
                                {OutcomeAndOnwardManagementOfTheCaseClassificationVisible ? (
                                    <>
                                        <DropdownQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={this.classificationQuestion}
                                            options={classificationQuestionOptions}
                                            mandatory
                                        />
                                        {(this.getAnswerToQuestionWithId("OutcomeAndOnwardManagementOfTheCaseClassification")
                                        === Classification.NotAtWorkMedicalCondition
                                        || this.getAnswerToQuestionWithId("OutcomeAndOnwardManagementOfTheCaseClassification")
                                        === Classification.NotAtWorkManagementIssue) ? (
                                                <OldDateQuestion
                                                    hideDivider
                                                    inline
                                                    readonly={this.props.readonly}
                                                    questionConfig={({
                                                        id: "OutcomeAndOnwardManagementOfTheCaseFirstDayOfAbsence",
                                                        questionText: "First Day of Absence"
                                                    })}
                                                    validators={[
                                                        createValidator((value: moment.Moment) => isDateInThePast(value), "This date must be in the past")
                                                    ]}
                                                    mandatory
                                                />
                                            ) : ("")}
                                    </>
                                ) : ("")}
                                {OutcomeAndOnwardManagementOfTheCaseFitnessToWorkVisible ? (
                                    <DropdownQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={this.fitnessToWorkQuestion}
                                        options={fitnessToWorkQuestionOptions}
                                        mandatory
                                    />
                                ) : ("")}
                                <DropdownQuestion
                                    hideDivider
                                    inline
                                    readonly={this.props.readonly}
                                    questionConfig={this.adjustmentsQuestion}
                                    options={adjustmentOptions}
                                    mandatory
                                />
                                {recommendedAdjustmentsQuestionVisible &&
                                    <MultiCheckboxQuestion
                                        hideDivider
                                        inline
                                        questionConfig={this.adjustmentsRecommendedQuestion}
                                        readonly={this.props.readonly}
                                        mandatory
                                        options={adjustmentsRecommendedOptions}
                                    >
                                        {(Object.keys(adjustmentsRecommendedOptions) as (keyof typeof adjustmentsRecommendedOptions)[]).map(k =>
                                            <MultiCheckbox key={k} value={k} label={adjustmentsRecommendedOptions[k]} />)}
                                    </MultiCheckboxQuestion>
                                }
                                {adjustmentEndDateQuestionVisible &&
                                    <OldDateQuestion
                                        hideDivider
                                        mandatory
                                        inline
                                        questionConfig={this.endDateOfTemporaryAdjustmentsQuestion}
                                        validators={[notInThePastValidator, notMoreThan12WeeksInTheFuture]}
                                        readonly={this.props.readonly}
                                    />
                                }
                            </AccordionQuestionnaireSection>
                        ) : ("")}
                    {(OutcomeAndOnwardManagementOfTheCaseEstimatedReturnToWorkDateVisible
                        || OutcomeAndOnwardManagementOfTheCasePhasedReturnVisible
                        || OutcomeAndOnwardManagementOfTheCaseCommentOnReturnToWorkVisible
                        || workClassificationNotAtWork) ? (
                            <AccordionQuestionnaireSection title="Return to Work" id={this.returnToWorkSectionId} hideNextButton active>
                                {
                                    this.props.useToyotaTemplates &&
                                    <>
                                        <DropdownQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={this.currentStatusQuestion}
                                            options={currentStatusOptions}
                                            mandatory
                                        />
                                        <DropdownQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "Level",
                                                questionText: "Level"
                                            })}
                                            options={this.props.useToyotaTemplates ? toyotaClinicalNotesLevelOptions : levelOptions}
                                            mandatory
                                        />
                                    </>
                                }
                                {(
                                    (
                                        workClassificationNotAtWork &&
                                        !this.props.useToyotaTemplates &&
                                        !this.isEmployeeIsUnlikelyToReturnForTheForeseeableFuture()
                                    ) || (
                                        this.props.useToyotaTemplates &&
                                        isCurrentStatusAbsent)
                                ) &&
                                    <OldDateQuestion
                                        hideDivider
                                        inline
                                        questionConfig={({
                                            id: "AdvisedTargetReturnToWorkDateNew",
                                            questionText: "Estimated Return to Work Date"
                                        })}
                                        readonly={this.props.readonly}
                                        mandatory
                                        outdated={{
                                            isOutdated: false,
                                            questionnaireKey: PHYSIOTHERAPY_REFERRAL_REPORT_KEY,
                                            sectionId: this.returnToWorkSectionId
                                        }}
                                        warning={{ validators: [dateInThePastWarning] }}
                                    />
                                }
                                {(!this.props.useToyotaTemplates) &&
                                    <>
                                        {!(this.props.readonly && !this.isEmployeeIsUnlikelyToReturnForTheForeseeableFuture()) &&
                                            <MultiButtonQuestion
                                                hideDivider
                                                inline
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "OutcomeAndOnwardManagementOfTheCaseEmployeeUnlikelyToReturn",
                                                    questionText: "Is employee unlikely to return for the foreseeable future?"
                                                })}
                                                mandatory
                                            />
                                        }
                                        {this.isEmployeeIsUnlikelyToReturnForTheForeseeableFuture() ? (
                                            <TextQuestion
                                                hideDivider
                                                inline
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "OutcomeAndOnwardManagementOfTheCaseEmployeeUnlikelyToReturnFurtherDetails",
                                                    questionText: "Further Details"
                                                })}
                                                multiline
                                                mandatory
                                                includeTextSnippetSelector
                                            />
                                        ) : ("")}
                                    </>

                                }
                                {OutcomeAndOnwardManagementOfTheCasePhasedReturnVisible ? (
                                    <>
                                        <MultiButtonQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "OutcomeAndOnwardManagementOfTheCasePhasedReturn",
                                                questionText: "Is a Phased Return to Work Required?"
                                            })}
                                            mandatory
                                        />
                                        {this.getAnswerToQuestionWithId("OutcomeAndOnwardManagementOfTheCasePhasedReturn") === YesOption ? (
                                            <DropdownQuestion
                                                hideDivider
                                                inline
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "OutcomeAndOnwardManagementOfTheCaseDurationOfPhasedReturn",
                                                    questionText: "Duration of Phased Return is recommended?"
                                                })}
                                                options={durationOfPhasedReturnQuestionOptionsLegacy}
                                                mandatory
                                            />
                                        ) : ("")}
                                    </>
                                ) : ("")}
                                {this.props.useToyotaTemplates && <>
                                    {isNotWorkingNormal &&
                                        <NumberQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "NumberOfWeeksToBeInPlace",
                                                questionText: "Number of Weeks to Be in Place"
                                            })}
                                            min={1}
                                            max={20}
                                            mandatory
                                        />
                                    }
                                    <MultiButtonQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "MedicalCertificateIssued",
                                            questionText: "Medical Certificate Issued?"
                                        })}
                                        mandatory
                                    />
                                </>}
                                {OutcomeAndOnwardManagementOfTheCaseCommentOnReturnToWorkVisible ? (
                                    <TextQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "OutcomeAndOnwardManagementOfTheCaseCommentOnReturnToWork",
                                            questionText: "Comments on Return to Work"
                                        })}
                                        multiline
                                        mandatory
                                        includeTextSnippetSelector
                                    />
                                ) : ("")}
                            </AccordionQuestionnaireSection>
                        ) : ("")}
                    {(FunctionalAssessmentTestsVisible || FunctionalCapacityCommentsOnFunctionalCapacityVisible) ? (
                        <AccordionQuestionnaireSection title="Functional Assessment Tests" id="FunctionalAssessmentTestsAnswers" hideNextButton active>
                            {functionalAssessmentTestsConfigs.map((assessmentTest: {
                                text: string;
                                value: string;
                                type: FunctionalAssessmentTestType;
                            }) =>
                                assessmentTest.type === FunctionalAssessmentTestType.Dropdown
                                    ? (
                                        <DropdownQuestion
                                            key={"FunctionalCapacity" + assessmentTest.value}
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "FunctionalCapacity" + assessmentTest.value,
                                                questionText: assessmentTest.text
                                            })}
                                            options={dropdownFunctionalAssessmentTestOptions}
                                            mandatory
                                        />
                                    )
                                    : (
                                        <TextQuestion
                                            key={"FunctionalCapacity" + assessmentTest.value}
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "FunctionalCapacity" + assessmentTest.value,
                                                questionText: assessmentTest.text
                                            })}
                                            multiline
                                            mandatory
                                            includeTextSnippetSelector
                                        />
                                    )
                            )}
                            {FunctionalCapacityCommentsOnFunctionalCapacityVisible ? (
                                <TextQuestion
                                    hideDivider
                                    inline
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "FunctionalCapacityCommentsOnFunctionalCapacity",
                                        questionText: "Comments on Functional Capacity"
                                    })}
                                    multiline
                                    includeTextSnippetSelector
                                />
                            ) : ("")}
                        </AccordionQuestionnaireSection>
                    ) : ("")}
                    {(PsychologicalWellbeingPHQ9OutcomeVisible
                        || PsychologicalWellbeingGAD7OutcomeVisible
                        || PsychologicalWellbeingWSASOutcomeVisible
                        || MentalHealthCommentsOnMentalAndEmotionalWellbeingVisible) ? (
                            <AccordionQuestionnaireSection
                                title="Mental and Emotional Health"
                                id={this.mentalAndEmotionalHealthSectionId}
                                hideNextButton
                                active
                            >
                                {PsychologicalWellbeingPHQ9OutcomeVisible ? (
                                    <DropdownQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "PsychologicalWellbeingPHQ9Outcome",
                                            questionText: "PHQ9 Outcome"
                                        })}
                                        options={psychologicalAssessmentOutcomeQuestionOptions.filter(o =>
                                            o.value === PsychologicalAssessmentOutcome.NotScored ||
                                            o.value === PsychologicalAssessmentOutcome.NoDepression ||
                                            o.value === PsychologicalAssessmentOutcome.MildDepression ||
                                            o.value === PsychologicalAssessmentOutcome.ModerateDepression ||
                                            o.value === PsychologicalAssessmentOutcome.ModeratelySevereDepression ||
                                            o.value === PsychologicalAssessmentOutcome.SevereDepression)}
                                        mandatory
                                        removable={{
                                            questionnaireKey: PHYSIOTHERAPY_REFERRAL_REPORT_KEY,
                                            sectionId: this.mentalAndEmotionalHealthSectionId
                                        }}
                                    />
                                ) : ("")}
                                {PsychologicalWellbeingGAD7OutcomeVisible ? (
                                    <DropdownQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "PsychologicalWellbeingGAD7Outcome",
                                            questionText: "GAD7 Outcome"
                                        })}
                                        options={getPsychologicalWellbeingGAD7OutcomeOptions()}
                                        mandatory
                                        removable={{
                                            questionnaireKey: PHYSIOTHERAPY_REFERRAL_REPORT_KEY,
                                            sectionId: this.mentalAndEmotionalHealthSectionId
                                        }}
                                    />
                                ) : ("")}
                                {PsychologicalWellbeingWSASOutcomeVisible ? (
                                    <DropdownQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "PsychologicalWellbeingWSASOutcome",
                                            questionText: "WSAS Outcome"
                                        })}
                                        options={getPsychologicalWellbeingWSASOutcomeOptions(this.props.readonly)}
                                        mandatory
                                        removable={{
                                            questionnaireKey: PHYSIOTHERAPY_REFERRAL_REPORT_KEY,
                                            sectionId: this.mentalAndEmotionalHealthSectionId
                                        }}
                                    />
                                ) : ("")}
                                {MentalHealthCommentsOnMentalAndEmotionalWellbeingVisible ? (
                                    <TextQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "MentalHealthCommentsOnMentalAndEmotionalWellbeing",
                                            questionText: "Comments on Mental and Emotional Wellbeing"
                                        })}
                                        multiline
                                        removable={{
                                            questionnaireKey: PHYSIOTHERAPY_REFERRAL_REPORT_KEY,
                                            sectionId: this.mentalAndEmotionalHealthSectionId
                                        }}
                                        includeTextSnippetSelector
                                    />
                                ) : ("")}
                            </AccordionQuestionnaireSection>
                        ) : ("")}
                    {BarriersVisible ? (
                        <AccordionQuestionnaireSection title="Barriers" id={this.barriersAnswersSectionId} hideNextButton active>
                            {barriers.map((barrier: { id: string; questionText: string }) =>
                                (<MultiButtonQuestion
                                    inline
                                    key={barrier.id}
                                    hideDivider
                                    readonly={this.props.readonly}
                                    questionConfig={(barrier)}
                                    mandatory
                                    removable={{
                                        questionnaireKey: PHYSIOTHERAPY_REFERRAL_REPORT_KEY,
                                        sectionId: this.barriersAnswersSectionId
                                    }}
                                />)
                            )}
                            {PsychosocialBarriersDetailsVisible ? (
                                <TextQuestion
                                    hideDivider
                                    inline
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "PsychosocialBarriersDetails",
                                        questionText: "Details"
                                    })}
                                    multiline
                                    removable={{
                                        questionnaireKey: PHYSIOTHERAPY_REFERRAL_REPORT_KEY,
                                        sectionId: this.barriersAnswersSectionId
                                    }}
                                    includeTextSnippetSelector
                                />
                            ) : ("")}
                        </AccordionQuestionnaireSection>
                    ) : ("")}
                    {StandardClinicalDetailsReasonForReferralVisible ? (
                        <AccordionQuestionnaireSection
                            title="Reason for referral including current health status and implications for work"
                            id="ReasonForReferral"
                            hideNextButton
                            active
                        >
                            <TextQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={({
                                    id: "StandardClinicalDetailsReasonForReferral",
                                    questionText: "Reason for referral including current health status and implications for work"
                                })}
                                multiline
                                includeTextSnippetSelector
                            />
                        </AccordionQuestionnaireSection>
                    ) : ("")}
                    {CurrentManagementOfHealthVisible ? (
                        <AccordionQuestionnaireSection
                            title="Reason for referral, current management of health and implications for work"
                            id="CurrentManagementOfHealth"
                            hideNextButton
                            active
                        >
                            <TextQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={({
                                    id: "CurrentManagementOfHealth",
                                    questionText: "Current management of health and implications for work"
                                })}
                                multiline
                                includeTextSnippetSelector
                            />
                        </AccordionQuestionnaireSection>
                    ) : ("")}
                    {FutureManagementOfHealthVisible ? (
                        <AccordionQuestionnaireSection
                            title="Future management of health and implications for work"
                            id="FutureManagementOfHealth"
                            hideNextButton
                            active
                        >
                            <TextQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={({
                                    id: "FutureManagementOfHealth",
                                    questionText: "Future management of health and implications for work"
                                })}
                                multiline
                                includeTextSnippetSelector
                            />
                        </AccordionQuestionnaireSection>
                    ) : ("")}
                    {OldAdditionalQuestionVisible ? (
                        <AccordionQuestionnaireSection
                            title="Answers to any Specific Questions asked in the Referral Form"
                            id="InformationRequiredAnswers"
                            hideNextButton
                            active
                        >
                            {this.getAnswerToQuestionWithId("AdditionalInfoOldAnswer") ?
                                <TextQuestion
                                    hidden={!this.props.readonly}
                                    readonly
                                    inline
                                    multiline
                                    questionConfig={({
                                        id: "AdditionalInfoOldAnswer",
                                        questionText: "Answers to any Specific Questions asked in the Referral Form" })}
                                /> :
                                <TextQuestion
                                    hidden={!this.props.readonly}
                                    readonly
                                    inline
                                    multiline
                                    questionConfig={({
                                        id: "AnswersToSpecificQuestions",
                                        questionText: "Answers to any Specific Questions asked in the Referral Form" })}
                                />
                            }
                            <TextQuestion
                                hidden={this.props.readonly}
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={({
                                    id: "AdditionalInfoOldAnswer",
                                    questionText: "Answers to any Specific Questions asked in the Referral Form"
                                })}
                                multiline
                                includeTextSnippetSelector
                            />
                        </AccordionQuestionnaireSection>
                    ) : ("")}
                    {NewSingleAdditionalQuestionVisible ? (
                        <AccordionQuestionnaireSection
                            title="Answers to any Specific Questions asked in the Referral Form"
                            id="InformationRequired"
                            hideNextButton
                            active
                        >
                            {this.getAnswerToQuestionWithId("AdditionalInfoOldAnswer") ?
                                <TextQuestion
                                    hidden={!this.props.readonly}
                                    readonly
                                    inline
                                    multiline
                                    questionConfig={({
                                        id: "AdditionalInfoOldAnswer",
                                        questionText: "Answers to any Specific Questions asked in the Referral Form" })}
                                /> :
                                <TextQuestion
                                    hidden={!this.props.readonly}
                                    readonly
                                    inline
                                    multiline
                                    questionConfig={({
                                        id: "AdditionalInfo",
                                        questionText: "Answers to any Specific Questions asked in the Referral Form" })}
                                />
                            }
                            <TextQuestion
                                hidden={this.props.readonly}
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={({
                                    id: "AdditionalInfoOldAnswer",
                                    questionText: "Answers to any Specific Questions asked in the Referral Form"
                                })}
                                multiline
                                includeTextSnippetSelector
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("SeparateAdditionalQuestionAnswersRequired")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("WorkRelated")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("ReturnDate")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("RestrictionsApply")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("AdjustmentsRequired")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("EqualityAct")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("FitToContinue")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("FitForDisciplinary")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("ReliableInFuture")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("ImpairedPerformance")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("ReferToSpecialist")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("AdditionalInfo")}
                            />
                            {!!this.getAnswerToQuestionWithId("WorkRelated") &&
                                <TextQuestion
                                    inline
                                    readonly={this.props.readonly}
                                    multiline
                                    questionConfig={({
                                        id: "WorkRelatedAnswer",
                                        questionText: this.getQuestionText("WorkRelated")
                                    })}
                                    includeTextSnippetSelector
                                />
                            }
                            {!!this.getAnswerToQuestionWithId("ReturnDate") &&
                                <TextQuestion
                                    inline
                                    readonly={this.props.readonly}
                                    multiline
                                    questionConfig={({
                                        id: "ReturnDateAnswer",
                                        questionText: this.getQuestionText("ReturnDate")
                                    })}
                                    includeTextSnippetSelector
                                />
                            }
                            {this.getAnswerToQuestionWithId("RestrictionsApply") &&
                                <TextQuestion
                                    inline
                                    readonly={this.props.readonly}
                                    multiline
                                    questionConfig={({
                                        id: "RestrictionsApplyAnswer",
                                        questionText: this.getQuestionText("RestrictionsApply")
                                    })}
                                    includeTextSnippetSelector
                                />
                            }
                            {this.getAnswerToQuestionWithId("AdjustmentsRequired") &&
                                <TextQuestion
                                    inline
                                    readonly={this.props.readonly}
                                    multiline
                                    questionConfig={({
                                        id: "AdjustmentsRequiredAnswer",
                                        /* eslint-disable max-len */
                                        questionText: this.getQuestionText("AdjustmentsRequired")
                                        /* eslint-enable max-len */
                                    })}
                                    includeTextSnippetSelector
                                />
                            }
                            {this.getAnswerToQuestionWithId("EqualityAct") &&
                                <TextQuestion
                                    inline
                                    readonly={this.props.readonly}
                                    multiline
                                    questionConfig={({
                                        id: "EqualityActAnswer",
                                        questionText: this.getQuestionText("EqualityAct")
                                    })}
                                    includeTextSnippetSelector
                                />
                            }
                            {this.getAnswerToQuestionWithId("FitToContinue") &&
                                <TextQuestion
                                    inline
                                    readonly={this.props.readonly}
                                    multiline
                                    questionConfig={({
                                        id: "FitToContinueAnswer",
                                        questionText: this.getQuestionText("FitToContinue")
                                    })}
                                    includeTextSnippetSelector
                                />
                            }
                            {this.getAnswerToQuestionWithId("FitForDisciplinary") &&
                                <TextQuestion
                                    inline
                                    readonly={this.props.readonly}
                                    multiline
                                    questionConfig={({
                                        id: "FitForDisciplinaryAnswer",
                                        questionText: this.getQuestionText("FitForDisciplinary")
                                    })}
                                    includeTextSnippetSelector
                                />
                            }
                            {this.getAnswerToQuestionWithId("ReliableInFuture") &&
                                <TextQuestion
                                    inline
                                    readonly={this.props.readonly}
                                    multiline
                                    questionConfig={({
                                        id: "ReliableInFutureAnswer",
                                        questionText: this.getQuestionText("ReliableInFuture")
                                    })}
                                    includeTextSnippetSelector
                                />
                            }
                            {this.getAnswerToQuestionWithId("ImpairedPerformance") &&
                                <TextQuestion
                                    inline
                                    readonly={this.props.readonly}
                                    multiline
                                    questionConfig={({
                                        id: "ImpairedPerformanceAnswer",
                                        questionText: this.getQuestionText("ImpairedPerformance")
                                    })}
                                    includeTextSnippetSelector
                                />
                            }
                            {this.getAnswerToQuestionWithId("ReferToSpecialist") &&
                                <TextQuestion
                                    inline
                                    readonly={this.props.readonly}
                                    multiline
                                    questionConfig={({
                                        id: "ReferToSpecialistAnswer",
                                        /* eslint-disable max-len */
                                        questionText: this.getQuestionText("ReferToSpecialist")
                                        /* eslint-enable max-len */
                                    })}
                                    includeTextSnippetSelector
                                />
                            }
                            {!!this.getAnswerToQuestionWithId("AdditionalInfo") &&
                                <TextQuestion
                                    hideDivider
                                    inline
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "AdditionalInfoAnswer",
                                        questionText: this.getQuestionText("AdditionalInfo")
                                    })}
                                    multiline
                                    includeTextSnippetSelector
                                />
                            }
                        </AccordionQuestionnaireSection>
                    ) : ("")}
                    {NewSeparateAdditionalQuestionRequired ? (
                        <AccordionQuestionnaireSection
                            title="Answers to any Specific Questions asked in the Referral Form"
                            id="InformationRequired"
                            hideNextButton
                            active
                        >
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("SeparateAdditionalQuestionAnswersRequired")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("WorkRelated")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("ReturnDate")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("RestrictionsApply")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("AdjustmentsRequired")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("EqualityAct")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("FitToContinue")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("FitForDisciplinary")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("ReliableInFuture")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("ImpairedPerformance")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("ReferToSpecialist")}
                            />
                            <TextQuestion
                                hidden
                                readonly
                                questionConfig={this.getQuestionsWithId("AdditionalInfo")}
                            />
                            {!!this.getAnswerToQuestionWithId("WorkRelated") &&
                                <TextQuestion
                                    inline
                                    readonly={this.props.readonly}
                                    multiline
                                    questionConfig={({
                                        id: "WorkRelatedAnswer",
                                        questionText: this.getQuestionText("WorkRelated") })}
                                    includeTextSnippetSelector
                                />
                            }
                            {!!this.getAnswerToQuestionWithId("ReturnDate") &&
                                <TextQuestion
                                    inline
                                    readonly={this.props.readonly}
                                    multiline
                                    questionConfig={({
                                        id: "ReturnDateAnswer",
                                        questionText: this.getQuestionText("ReturnDate") })}
                                    includeTextSnippetSelector
                                />
                            }
                            {this.getAnswerToQuestionWithId("RestrictionsApply") &&
                                <TextQuestion
                                    inline
                                    readonly={this.props.readonly}
                                    multiline
                                    questionConfig={({
                                        id: "RestrictionsApplyAnswer",
                                        questionText: this.getQuestionText("RestrictionsApply") })}
                                    includeTextSnippetSelector
                                />
                            }
                            {this.getAnswerToQuestionWithId("AdjustmentsRequired") &&
                                <TextQuestion
                                    inline
                                    readonly={this.props.readonly}
                                    multiline
                                    questionConfig={({
                                        id: "AdjustmentsRequiredAnswer",
                                        /* eslint-disable max-len */
                                        questionText: this.getQuestionText("AdjustmentsRequired")
                                        /* eslint-enable max-len */
                                    })}
                                    includeTextSnippetSelector
                                />
                            }
                            {this.getAnswerToQuestionWithId("EqualityAct") &&
                                <TextQuestion
                                    inline
                                    readonly={this.props.readonly}
                                    multiline
                                    questionConfig={({
                                        id: "EqualityActAnswer",
                                        questionText: this.getQuestionText("EqualityAct")
                                    })}
                                    includeTextSnippetSelector
                                />
                            }
                            {this.getAnswerToQuestionWithId("FitToContinue") &&
                                <TextQuestion
                                    inline
                                    readonly={this.props.readonly}
                                    multiline
                                    questionConfig={({
                                        id: "FitToContinueAnswer",
                                        questionText: this.getQuestionText("FitToContinue")
                                    })}
                                    includeTextSnippetSelector
                                />
                            }
                            {this.getAnswerToQuestionWithId("FitForDisciplinary") &&
                                <TextQuestion
                                    inline
                                    readonly={this.props.readonly}
                                    multiline
                                    questionConfig={({
                                        id: "FitForDisciplinaryAnswer",
                                        questionText: this.getQuestionText("FitForDisciplinary")
                                    })}
                                    includeTextSnippetSelector
                                />
                            }
                            {this.getAnswerToQuestionWithId("ReliableInFuture") &&
                                <TextQuestion
                                    inline
                                    readonly={this.props.readonly}
                                    multiline
                                    questionConfig={({
                                        id: "ReliableInFutureAnswer",
                                        questionText: this.getQuestionText("ReliableInFuture")
                                    })}
                                    includeTextSnippetSelector
                                />
                            }
                            {this.getAnswerToQuestionWithId("ImpairedPerformance") &&
                                <TextQuestion
                                    inline
                                    readonly={this.props.readonly}
                                    multiline
                                    questionConfig={({
                                        id: "ImpairedPerformanceAnswer",
                                        questionText: this.getQuestionText("ImpairedPerformance")
                                    })}
                                    includeTextSnippetSelector
                                />
                            }
                            {this.getAnswerToQuestionWithId("ReferToSpecialist") &&
                                <TextQuestion
                                    inline
                                    readonly={this.props.readonly}
                                    multiline
                                    questionConfig={({
                                        id: "ReferToSpecialistAnswer",
                                        /* eslint-disable max-len */
                                        questionText: this.getQuestionText("ReferToSpecialist")
                                        /* eslint-enable max-len */
                                    })}
                                    includeTextSnippetSelector
                                />
                            }
                            {!!this.getAnswerToQuestionWithId("AdditionalInfo") &&
                                <TextQuestion
                                    hideDivider
                                    inline
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "AdditionalInfoAnswer",
                                        questionText: this.getQuestionText("AdditionalInfo")
                                    })}
                                    multiline
                                    includeTextSnippetSelector
                                />
                            }
                        </AccordionQuestionnaireSection>
                    ) : ("")}
                    {NotesVisible ? (
                        <AccordionQuestionnaireSection title="Report" id="Report" hideNextButton active>
                            <TextQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={({
                                    id: "Notes",
                                    questionText: "Report"
                                })}
                                multiline
                                mandatory
                                rowCount={48}
                                includeTextSnippetSelector
                            />
                        </AccordionQuestionnaireSection>
                    ) : ("")}
                    {OutcomeAndOnwardManagementOfTheCaseRiskAssessmentRecommendationsVisible ? (
                        <AccordionQuestionnaireSection title="Risk Assessment Recommendations" id="RiskAssessmentRecommendations" hideNextButton active>
                            <DropdownQuestion
                                hideDivider
                                inline
                                readonly={this.props.readonly}
                                questionConfig={({
                                    id: "OutcomeAndOnwardManagementOfTheCaseRiskAssessmentRecommendations",
                                    questionText: "Risk Assessment Recommendations"
                                })}
                                options={riskAssessmentRecommendationQuestionOptions}
                                mandatory
                                multiple
                            />
                            {choosenRiskAssessmentRecommendations.some(d => d === RiskAssessmentRecommendation.OtherPleaseProvideDetails) &&
                                <TextQuestion
                                    hideDivider
                                    inline
                                    readonly={this.props.readonly}
                                    questionConfig={({
                                        id: "OutcomeAndOnwardManagementOfTheCaseRiskAssessmentRecommendationsOther",
                                        questionText: "Details"
                                    })}
                                    multiline
                                    mandatory
                                    includeTextSnippetSelector
                                />
                            }
                        </AccordionQuestionnaireSection>
                    ) : ("")}
                    {(OutcomeAndOnwardManagementOfTheCaseDescriptionOfThePhysicalOrMentalImpairmentVisible
                        || OutcomeAndOnwardManagementOfTheCaseDurationOfMedicalConditionVisible
                        || OutcomeAndOnwardManagementOfTheCaseEffectOfMedicalConditionVisible
                        || OutcomeAndOnwardManagementOfTheCaseApplyEqualityActVisible) ? (
                            <AccordionQuestionnaireSection title="Employment Law (including Equality Act 2010)" id="EqualityAct" hideNextButton active>
                                {OutcomeAndOnwardManagementOfTheCaseDescriptionOfThePhysicalOrMentalImpairmentVisible ? (
                                    <TextQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "OutcomeAndOnwardManagementOfTheCaseDescriptionOfThePhysicalOrMentalImpairment",
                                            questionText: "Description of the Physical or Mental Impairment"
                                        })}
                                        multiline
                                        mandatory
                                        includeTextSnippetSelector
                                    />
                                ) : ("")}
                                {OutcomeAndOnwardManagementOfTheCaseDurationOfMedicalConditionVisible ? (
                                    <DropdownQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "OutcomeAndOnwardManagementOfTheCaseDurationOfMedicalCondition",
                                            questionText: "Duration of Medical Condition"
                                        })}
                                        options={durationOfMedicalConditionQuestionOptions}
                                        mandatory
                                    />
                                ) : ("")}
                                {OutcomeAndOnwardManagementOfTheCaseEffectOfMedicalConditionVisible ? (
                                    <TextQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "OutcomeAndOnwardManagementOfTheCaseEffectOfMedicalCondition",
                                            questionText: "Effect of Medical Condition on Normal Day to Day Activities"
                                        })}
                                        multiline
                                        mandatory
                                        includeTextSnippetSelector
                                    />
                                ) : ("")}
                                {OutcomeAndOnwardManagementOfTheCaseApplyEqualityActVisible ? (
                                    <DropdownQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={this.outcomeAndOnwardManagementOfTheCaseApplyEqualityActQuestion}
                                        options={applyEqualityActQuestionOptions}
                                        mandatory
                                        hidden={outcomeAndOnwardManagementOfTheCaseApplyEqualityActQuestionAnswer === ApplyEqualityAct.NotAnswered}
                                    />
                                ) : ("")}
                            </AccordionQuestionnaireSection>
                        ) : ("")}
                    {(OutcomeAndOnwardManagementOfTheCaseDetailsOfOnwardReferralVisible
                        || OutcomeAndOnwardManagementOfTheCaseDetailsOfFurtherAppointmentsVisible
                        || OutcomeAndOnwardManagementOfTheCaseFurtherMedicalInformationBeingRequestedVisible) ? (
                            <AccordionQuestionnaireSection title="Onward Clinical Management of the Case" id="OnwardClinicalManagement" hideNextButton active>
                                {OutcomeAndOnwardManagementOfTheCaseDetailsOfOnwardReferralVisible ? (
                                    <>
                                        <DropdownQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "OutcomeAndOnwardManagementOfTheCaseDetailsOfOnwardReferral",
                                                questionText: "Details of any Onward Referral to Support Services being Made"
                                            })}
                                            options={detailsOfOnwardReferralQuestionOptions}
                                            mandatory
                                            multiple
                                        />
                                        {choosenDetailsOfOnwardReferral.some(d => d === DetailsOfOnwardReferral.OtherDetailsBelow) &&
                                            <TextQuestion
                                                hideDivider
                                                inline
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "OutcomeAndOnwardManagementOfTheCaseDetailsOfOnwardReferralOther",
                                                    questionText: "Details"
                                                })}
                                                multiline
                                                mandatory
                                                includeTextSnippetSelector
                                            />
                                        }
                                    </>
                                ) : ("")}
                                {OutcomeAndOnwardManagementOfTheCaseDetailsOfFurtherAppointmentsVisible ? (
                                    <DropdownQuestion
                                        hideDivider
                                        inline
                                        readonly={this.props.readonly}
                                        questionConfig={({
                                            id: "OutcomeAndOnwardManagementOfTheCaseDetailsOfFurtherAppointments",
                                            questionText: "Details of any further appointments to be arranged with Occupational Health"
                                        })}
                                        options={detailsOfFurtherAppointmentsQuestionOptions}
                                        mandatory
                                        multiple
                                    />
                                ) : ("")}
                                {OutcomeAndOnwardManagementOfTheCaseFurtherMedicalInformationBeingRequestedVisible ? (
                                    <>
                                        <MultiButtonQuestion
                                            hideDivider
                                            inline
                                            readonly={this.props.readonly}
                                            questionConfig={({
                                                id: "OutcomeAndOnwardManagementOfTheCaseFurtherMedicalInformationBeingRequested",
                                                questionText: "Further Medical Information being requested"
                                            })}
                                            mandatory
                                        />
                                        {this.getAnswerToQuestionWithId("OutcomeAndOnwardManagementOfTheCaseFurtherMedicalInformationBeingRequested")
                                            === YesOption &&
                                            <TextQuestion
                                                hideDivider
                                                inline
                                                readonly={this.props.readonly}
                                                questionConfig={({
                                                    id: "OutcomeAndOnwardManagementOfTheCaseFurtherMedicalInformationBeingRequestedDetails",
                                                    questionText: "Comments"
                                                })}
                                                multiline
                                                mandatory
                                                includeTextSnippetSelector
                                            />
                                        }
                                    </>
                                ) : ("")}
                            </AccordionQuestionnaireSection>
                        ) : ("")}
                    {
                        this.props.extraSections && this.props.extraSections.map((s, i) =>
                            (<AccordionQuestionnaireSection key={i} title={s.title} id={s.id} hideNextButton={true} active={true} neverHide={true}>
                                {s.content}
                            </AccordionQuestionnaireSection>))
                    }
                </AccordionQuestionnaireContainer>
                {this.props.readonly &&
                    <>
                        <Segment basic>
                            <p>
                                The above information is advisory only. The possibility of implementing any suggestions is purely a decision by the employer,
                                for example, any rehabilitation programme or adjustment to working practice must be agreed by the employer, taking into account
                                the needs of the service and any constraints within the context of the work environment.
                            </p>
                            <p>
                                I hope you find this information useful. Please do not hesitate to contact us with any queries.
                            </p>
                        </Segment>
                        <Segment basic>
                            <p>
                                <strong>{this.state.readonlyData?.ClinicianName}</strong>
                                <br />
                                <i>{this.state.readonlyData?.ClinicianJobTitle}</i>
                            </p>
                            <p>
                                {this.state.readonlyData?.ClinicianQualifications}
                            </p>
                            <p>
                                Please note that any advice given and suggested adjustments contained within this report are purely recommendations and the
                                opinion of the clinician. It is ultimately a management decision as to whether or not these can be
                                accommodated.
                            </p>
                            <p>
                                If you would like to discuss this report or require further information or advice, please do not hesitate to contact
                                us: {this.state.readonlyData?.CustomerEmail} or call {this.state.readonlyData?.CustomerPhone}.
                            </p>
                        </Segment>
                        <EmployeeReleaseReportWithCommentsInfo reportDetails={this.props.reportDetails} />
                        <Divider />
                        <Container>
                            <p>
                                Printing Disclaimer:  This report contains personal identifiable information and sensitive health details.
                                It is possible to print this report or create a pdf of this report using your in-browser printing however
                                we would strongly recommend that you only view this report in the system and avoid printing where ever possible.
                                If you do choose to print or export this information then you do so at your own risk and you must take all necessary
                                measures to protect the information contained within this report and ensure that it is only viewed by authorised
                                personnel within your own organisation.
                            </p>
                            <PrintDialog />
                        </Container>
                    </>
                }
            </Container>
        );
    }
}
